import GridContainer from "../components/GridContainer";
import ProjectDetails from "../components/projects/ProjectDetails";
import ProjectBody from "../components/projects/ProjectBody";
import TextLink from "../components/TextLink";
import ProjectTitle from "../components/projects/ProjectTitle";
import ProjectHero from "../components/projects/ProjectHero";
import LinkCard from "../components/projects/LinkCard";
import Divider from "../components/projects/Divider";

export default function Kashima() {
    return (
        <GridContainer>
            <ProjectHero content="https://i.imgur.com/iX3uAbb.png" />
            <ProjectTitle role="discord bot">KASHIMA</ProjectTitle>
            <ProjectBody col={2}>
                This project is a redesign of the original{' '}
                <TextLink link="https://kashima.saya.moe/">
                    Kashima website
                </TextLink>
                {' '}serving as a central hub to showcase{' '}
                <TextLink link="https://discord.bots.gg/bots/424137718961012737">Kashima’s features</TextLink>,{' '}
                and provide an intuitive web-based music player and controller. The new site allows users to easily queue, pause, and control music playback without needing to type commands manually, making music management seamless on the go. Additionally, the website offers a convenient interface for users to configure Kashima’s settings directly. enhancing user experience by simplifying bot management.
            </ProjectBody>
            <ProjectDetails
                role={['Web Developer & Designer']}
                collaborators={['Saya', '0t4u']}
                duration={['2025 - Present']}
                tools={['Figma', 'React', 'Aseprite']}
            />
            <Divider />
            <LinkCard col={1} link="https://github.com/shipgirlproject/Kashima-website-new">VISIT THE REPOSITORY</LinkCard>
            <LinkCard col={2} link="https://discord.com/api/oauth2/authorize?client_id=424137718961012737&permissions=137744477510&scope=bot%20applications.commands">INVITE KASHIMA</LinkCard>

            {/* <ProjectBody title="KASHIMA MUSIC WEB CONTROLLER"></ProjectBody> */}

        </GridContainer>
    )
}